import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Mark = styled.mark `
  font-size: inherit;
  font-style: inherit;
  font-weight: ${themeGet('fontWeight.semibold')};
  text-decoration: underline;
  background: transparent;
`;
